"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_query_1 = require("react-query");
const ObjectivesClient_1 = require("client/ObjectivesClient");
const HelperUtils_1 = require("utils/HelperUtils");
const BannerBox_1 = __importDefault(require("components/shared/BannerBox"));
const ApprovalWarnings = ({ objectiveId, warningList, setWarningList }) => {
    const [showWarningList, setShowWarningList] = (0, react_1.useState)(false);
    const fetchChildrenRequirements = () => {
        const query = {
            metadata: 'requirements'
        };
        return (0, ObjectivesClient_1.getObjectiveChildren)(objectiveId, query);
    };
    (0, react_query_1.useQuery)(['teamGoals', 'approval', 'approvalWarnings', objectiveId], fetchChildrenRequirements, {
        onSuccess: (data) => {
            var _a, _b, _c;
            if ((_a = data === null || data === void 0 ? void 0 : data.metadata) === null || _a === void 0 ? void 0 : _a.metadata) {
                setWarningList((_c = (_b = data === null || data === void 0 ? void 0 : data.metadata) === null || _b === void 0 ? void 0 : _b.metadata) === null || _c === void 0 ? void 0 : _c.requirements);
            }
        }
    });
    return (react_1.default.createElement(react_1.default.Fragment, null, (warningList === null || warningList === void 0 ? void 0 : warningList.length) > 0 && (react_1.default.createElement("div", { className: "mt-[16px]" },
        react_1.default.createElement(BannerBox_1.default, { type: "error", text: (0, HelperUtils_1.getObjectiveLocale)("You can't request approval because these goals do not fulfill the requirements"), action: {
                text: (0, HelperUtils_1.getObjectiveLocale)(`${showWarningList ? 'Hide' : 'Show'} Requirements`),
                onClick: () => setShowWarningList(!showWarningList)
            }, marginClass: "mb-[0px]", paddingClass: "px-[16px] py-[8px]", borderRadiusClass: showWarningList ? '!rounded-t-[8px]' : '!rounded-[8px]' }),
        showWarningList && (react_1.default.createElement("div", { className: "bg-r-200 rounded-b-[8px] pl-[56px] pr-[16px] pb-[8px]" }, warningList === null || warningList === void 0 ? void 0 : warningList.map((warning, index) => (react_1.default.createElement("div", { className: "flex items-center py-[4px]", key: index },
            react_1.default.createElement("div", { className: "rounded-full bg-n-900 h-[4px] w-[4px] mx-[8px]" }),
            react_1.default.createElement("p", { className: "typography-paragraph text-n-900" }, warning))))))))));
};
exports.default = ApprovalWarnings;
